import { withLayout } from '../../layout';

import HomePage from './home.page';

export default withLayout(HomePage);
